import React from "react";

const About = () => {
  return (
    <main className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold mb-4 dark:text-white">About ProvocaBot</h1>
        <div className="space-y-4 text-gray-700 dark:text-gray-300">
          <p>
            This application is designed to challenge your thinking and spark new
            ideas by generating thought-provoking provocations.
          </p>
          <p>
            Whether you're a designer, a strategist, an innovator, or just someone
            looking for a fresh perspective, the ProvocaBot is here to help
            you break free from conventional thought patterns.
          </p>
          <h2 className="text-2xl font-bold pt-4 dark:text-white">How It Works</h2>
          <p>
            Simply enter a problem statement or a topic you're exploring, and the
            bot will provide you with a series of provocations. These are not
            solutions, but rather challenging statements or questions designed to
            make you think differently.
          </p>
          <h2 className="text-2xl font-bold pt-4 dark:text-white">The Team</h2>
          <p>
            This project was created by &nbsp;
            <a
              href="https://www.iShipCode.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 dark:text-primary-400 hover:underline"
            >
              Adrian Scott
            </a>
            .
          </p>
        </div>
      </div>
    </main>
  );
};

export default About;
